import React from 'react';
import {Link} from "react-router-dom";
import Header from '../modules/header'
import $ from "jquery";
import Footerslider from '../components/FooterSlider/footerslider';
import Slider from "react-slick";
import axios from 'axios';
import toast from 'toasted-notes';
import parse from 'html-react-parser';

import noimage from '../assets/images/yachts/noimage.png';
import default_background from '../assets/images/yachts/image-33.png';
import motoryatch from '../assets/images/yachts/image-16.png';
import check from '../assets/images/Yahct/checkmark.svg';
import yatchimg from '../assets/images/Yahct/Hot Tube.jpg';
import yatchimg1 from '../assets/images/yachts/image-1.png';
import yatchimg2 from '../assets/images/yachts/image-2.png';
import yatchimg3 from '../assets/images/Yahct/Outside Dining 1.jpg';
import yatchimg4 from '../assets/images/Yahct/Sun Deck 1.jpg';
import yatchimg5 from '../assets/images/Yahct/Outside Dining 2.jpg';
import yatchim from '../assets/images/Yahct/Sun Deck 2.jpg';
import btnarow from '../assets/images/icons/button-arrow.svg';
import Games from '../assets/images/Yahct/Games Consols.svg';
import Freewifi from '../assets/images/Yahct/free-wifi.png';
import Satellite from '../assets/images/Yahct/satellite.svg';
import Airconditioning from '../assets/images/Yahct/Air Conditioning.svg';
import Deck from '../assets/images/Yahct/Deck Jacuzzi.svg';
import Ipod from '../assets/images/Yahct/Ipod Docking.svg';
import Sauna from '../assets/images/Yahct/Sauna.svg';
import image26 from '../assets/images/yachts/image-26.png';
import wheel from '../assets/images/Yahct/wheel.svg';
import yachtvector from '../assets/images/Yahct/vector1.svg';
import icon1 from '../assets/images/Yahct/Guest.svg';
import icon2 from '../assets/images/Yahct/Cabins.svg';
import icon3 from '../assets/images/Yahct/Crew.svg';
import img36 from '../assets/images/yachts/image-36.png';
import img1 from '../assets/images/yachts/slider1.png';
import img18 from '../assets/images/yachts/image-18.png';
import img20 from '../assets/images/yachts/image-20.png';
import img19 from '../assets/images/yachts/image-19.png';
import vector4 from '../assets/images/Yahct/vector3.svg';
import img34 from '../assets/images/yachts/image-32.png';
import btnarow3 from '../assets/images/icons/button-arrow.svg';
import Footer from '../modules/footer';
import ModalVideo from './video-modal';

class SimpleSlider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeSlide: 0,
            yacht: {},
            sliderCount: 0,
            isOpen: false,
            destination_one: null,
            destination_two: null,
            testimonial_one: null,
            testimonial_two: null,
            SliderImages:[],
            SliderImages1:[yatchimg1,yatchimg2,yatchimg2, yatchimg3]
        };
        this.openModal = this.openModal.bind(this)
    }

    openModal () {
        if(this.state.yacht && this.state.yacht.video && this.state.yacht.video.url ) {
            this.setState({isOpen: true});
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)

      const yacht_id = this.props.match.params.id;
      var user_id = 0;
      if(sessionStorage.getItem('user')) {
        user_id = JSON.parse(sessionStorage.getItem('user')).id;
      }
      console.log('user_id', user_id)

      axios.get(`${process.env.REACT_APP_API_URL}/yachts/${yacht_id}?user_id=${user_id}`)
        .then((response) => {
            console.log(response.data.yacht);
            this.setState({
                yacht: response.data.yacht,
                sliderCount: response.data.yacht.images.length,
                destination_one: response.data.destination_one,
                destination_two: response.data.destination_two,
                testimonial_one: response.data.testimonial_one,
                testimonial_two: response.data.testimonial_two
            });
            if(response.data.yacht && response.data.yacht.images){
                let SliderImages = []
                response.data.yacht.images.map((image, index) => {
                    SliderImages.push(image.slider.url)
                })

                console.log('SliderImages', SliderImages)
                this.setState({SliderImages:SliderImages})
            }
            if(response.data.favourite){
                $('.activestar span').addClass('filledstar');
                $('.activestar span').html("&#9733;");
            } else{
                $('.activestar span').removeClass('filledstar');
                $('.activestar span').html("&#9734;");
            }
            window.scrollTo(0, 0)
        })
        .catch();

        // backto top jquery
        if ($('#back-to-top').length) {
            var scrollTrigger = 100, // px
                backToTop = function () {
                    var scrollTop = $(window).scrollTop();
                    if (scrollTop > scrollTrigger) {
                        $('#back-to-top').addClass('show');
                    } else {
                        $('#back-to-top').removeClass('show');
                    }
                };
            backToTop();
            $(window).on('scroll', function () {
                backToTop();
            });
            $('#back-to-top').on('click', function (e) {
                e.preventDefault();
                $('html,body').animate({
                    scrollTop: 0
                }, 700);
            });
        }

        $(".activestar").click(function() {
            if(!sessionStorage.getItem('user')) {
                toast.notify('Sign in to add favourite');
            }
            else {
                user_id = JSON.parse(sessionStorage.getItem('user')).id;

                axios.post(`${process.env.REACT_APP_API_URL}/yachts/${yacht_id}/toggle_favourite.json`, {user_id: user_id})
                    .then((response) => {
                        if($('.activestar span').hasClass( "filledstar" )){
                            $('.activestar span').removeClass('filledstar');
                            $('.activestar span').html("&#9734;");
                        }else{
                            $('.activestar span').addClass('filledstar');
                            $('.activestar span').html("&#9733;");
                        }
                    })
                    .catch();
            }

          });

    }

    componentDidUpdate() {
        if(this.state.yacht && this.state.yacht.video && this.state.yacht.video.url ) {
            if($(".modal-video-movie-wrap iframe").length > 0) {
                $(".modal-video-movie-wrap iframe").src = this.state.yacht.video.url;
            }
        }
    }

    render() {

        const settings = {
            className: "center",
            // centerMode: true,
            infinite: true,
            swipeToSlide :true,
            // centerPadding: "0",
            slidesToShow: 2,
            speed: 500,
            slidesPerRow: 1,
            slidesToScroll: 1,
            focusOnSelect: true,
            dots: true,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesPerRow: 1,
                        centerMode: false,
                        arrows: false
                    }
                }
            ],
            beforeChange: (current, next) => this.setState({oldSlide: current, activeSlide: next === -1 ? 0 : next}),
            afterChange: current => this.setState({activeSlide2: current})
          };
        const yacht = this.state.yacht;
        // console.log('yacht==>>>', yacht, this.state.SliderImages)

        const backgroundStyle = {
            backgroundImage: `url(${yacht && yacht.main_image && yacht.main_image.url ? yacht.main_image.url : ''})`
        }

        return (
            <div className="open_menudiv" style={{'overflowX': 'hidden'}}>
                <ModalVideo isOpen={this.state.isOpen} onClose={() => this.setState({isOpen: false})} channel="custom" videoId={ yacht && yacht.video && yacht.video.url ? yacht.video.url : ''} />
                <Header></Header>

                <div className="hero-slider section home-hero" id="main_sec">
                    <div className="hero-item" id="yacht_sec" style={backgroundStyle}>
                        <div className="slider-dark-overlay"></div>
                        <div className="container">
                            <div className="row" id="yacht_posi">
                                <div className="hero-content-wrap col" id="yacht_contents">
                                    <div className="hero-content" id="yacht_page">
                                        <div className="row">
                                            <div className="col-lg-8 col-md-8">
                                                <div className="single-yacht-details">
                                                    <p className="type">INTRODUCING</p>
                                                    <h1 className="name">{yacht.name}</h1>
                                                    <p className="details">{yacht.length} m / {Math.round(yacht.length * 3.28)} ft | {yacht && yacht.type && yacht.type.name} | {yacht.build_year}</p>
                                                    {
                                                        yacht.category === "charter" ? <p className="price">From €{ yacht.charter_price } p/week + expenses</p> : <p className="price">Listing Price €{yacht.sale_price}</p>
                                                    }

                                                </div>
                                            </div>

                                            <div className="col-lg-2 col-md-2">
                                                {
                                                    yacht && yacht.video && yacht.video.url ?
                                                    <div className="video-play destination-video">
                                                        <div id="video_container" className="Videoscreen" onClick={this.openModal}>
                                                            <div className="flex">
                                                                <div className="vid htmlvid" id="playicon-charter"></div>
                                                                <p className="watch_videop">Watch our video
                                                                    <br/>about charter</p>
                                                            </div>
                                                        </div>
                                                        <p className="mobile-video-title">Watch our video about charter</p>
                                                    </div>
                                                    :
                                                    false
                                                }

                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="yacht-destination">
                                                    <div className="des-image">
                                                        <img src={motoryatch} className="img-responsive" alt="motoryatch"/>
                                                    </div>
                                                    <div className="place-name">
                                                        <p className="region">Cruising Regions:</p>
                                                        <p>{ yacht && yacht.sailing_countries && yacht.sailing_countries.map(e => e.name).join(", ") }</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {/* Second section */}
                <section id="quote-quote-section" className="section fix quote-quote-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="row name-price">
                                    <div className="col-lg-4 col-md-6 col-6 no-padding">
                                        <div className="date-from-to">
                                            <p className="year-month">
                                                {yacht && yacht.type && yacht.type.name}
                                            </p>
                                            <p className="yacht-range">
                                                {yacht.name}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-6 col-6 no-padding">
                                        <div className="price-from-div">
                                            {
                                                yacht.category === "charter" ?
                                                [
                                                <p className="price-from">From</p>,
                                                <p className="total-price">€{ yacht.charter_price }
                                                    <span>p/week</span>
                                                </p>
                                                ]
                                                :
                                                [
                                                <p className="price-from">Listing Price</p>,
                                                <p className="total-price">€{yacht.sale_price}
                                                </p>
                                                ]
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 no-padding">
                                <div className="row btns-div">
                                    <div className="activestar">
                                        <span className="starrating">&#9734;</span>
                                        <div className="tooltiptext">Add to Favourites</div>
                                    </div>
                                    { yacht.category === "charter" ?
                                    <div className="back-btnyacht">
                                        <Link to={"/yacht/" + yacht.id + "/dates"}><button className="btn btn-secondary btn-theme2 check-avail">Check Availability</button></Link>
                                    </div> : ''
                                    }
                                    { yacht.category === "charter" ?
                                    <div className="get-quote-btn">
                                        <Link to={"/yacht/" + yacht.id + "/get-quote"}>
                                        <button className="btn btn-secondary btn-theme get-quote-btn-link">
                                            <span>Get A Quote</span>
                                            <div className="button-arrow">
                                                <img src={btnarow} className="img-responsive" alt="arrow"/>
                                            </div>
                                        </button>
                                        </Link>
                                    </div>
                                    :
                                    <div className="get-quote-btn">
                                        <a href="mailto:info@exclusivegulets.com">
                                        <button className="btn btn-secondary btn-theme get-quote-btn-link">
                                            <span>Enquire</span>
                                            <div className="button-arrow">
                                                <img src={btnarow} className="img-responsive" alt="arrow"/>
                                            </div>
                                        </button>
                                        </a>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Third section  */}
                <section id="about-yacht" className="section fix about-yacht">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="about-yacht-content">
                                    <div className="about-txt">
                                        <h1>About {yacht && yacht.name}</h1>
                                        <p>
                                            { yacht && yacht.about && parse(yacht.about) }
                                        </p>
                                    </div>
                                    <div className="aboutyacht-imgmob">
                                        <img src={yacht && yacht.side_image && yacht.side_image.url ? yacht.side_image.side.url : image26} className="img-responsive" alt="aboutyacht"/>
                                    </div>
                                    <div className="about-yacht-amenities">
                                        <h1>Amenities & Entertainment</h1>
                                        <p>{yacht && yacht.entertainment && parse(yacht.entertainment) }</p>

                                        <div className="amenities-list">
                                            { yacht && yacht.entertainments && yacht.entertainments.map((e, index) => {
                                                return [
                                                <div className="list">
                                                    <div className="amen-icon">
                                                        <img src={e.image} className="img-responsive" alt="Games Consols"/>
                                                    </div>
                                                    <div className="amen-text">{e.name}</div>
                                                </div>
                                                ];
                                            })}
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 no-padding" id="aboutyach_desktop">
                                <div className="aboutyacht-img">
                                    <img src={yacht && yacht.side_image && yacht.side_image.url ? yacht.side_image.side.url : image26} className="img-responsive" alt="aboutyacht-img" />
                                </div>
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="about-yacht-content yacht-metadata">
                                <div className="about-yacht-amenities">
                                        <h1>Key Features</h1>
                                        <div className="amenities-list">
                                            { yacht && yacht.key_features && yacht.key_features.map((e, index) => {
                                                return [
                                                <div className="list">

                                                    <div className="amen-text">{e.name}</div>
                                                </div>
                                                ];
                                            })}
                                        </div>

                                    </div>

                                    <div className="about-yacht-amenities">
                                        <h1>Water Toys</h1>
                                        <div className="amenities-list">
                                            { yacht && yacht.toys && yacht.toys.map((e, index) => {
                                                return [
                                                <div className="list">

                                                    <div className="amen-text">{e.name}</div>
                                                </div>
                                                ];
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    <div className="yachbackground-vector2">
                        <img src={wheel} className="img-responsive" alt="Wheel vector"/>
                    </div>
                </section>

                {/* Fourth section */}
                <section id="yachts-grids" className="yachts-grids section fix">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 no-padding yacht1">
                                <div className="yacht-content" id="norman_content">
                                    <a href="#">
                                        <div className="slider-dark-overlay2"
                                             style={{
                                                 backgroundImage: `url(${yacht && yacht.featured_image_1 &&
                                                 yacht.featured_image_1.url ? yacht.featured_image_1.url : yatchimg})`
                                             }}
                                        />
                                        <div className="yacht-text">
                                            <h2>{ yacht && yacht.featured_title_1}</h2>
                                            <p>{ yacht && yacht.featured_description_1 && parse(yacht.featured_description_1)}</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-8">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 no-padding yacht2">
                                        <div className="yacht-content" id="norman_content">
                                            <a href="#">
                                                <div className="slider-dark-overlay2"
                                                    style={{
                                                        backgroundImage: `url(${yacht && yacht.featured_image_2 &&
                                                        yacht.featured_image_2.url ? yacht.featured_image_2.url : yatchimg})`
                                                    }}/>
                                                <div className="yacht-text align-bottom">
                                                <h2>{ yacht && yacht.featured_title_2}</h2>
                                                <p>{ yacht && yacht.featured_description_2 && parse(yacht.featured_description_2)}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 no-padding yacht3">
                                        <div className="yacht-content" id="norman_content">
                                            <a href="#">
                                                <div className="slider-dark-overlay2"
                                                    style={{
                                                        backgroundImage: `url(${yacht && yacht.featured_image_3 &&
                                                        yacht.featured_image_3.url ? yacht.featured_image_3.url : yatchimg})`
                                                    }}
                                                />
                                                <div className="yacht-text align-bottom">
                                                <h2>{ yacht && yacht.featured_title_3}</h2>
                                            <p>{ yacht && yacht.featured_description_3 && parse(yacht.featured_description_3)}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 no-padding yacht4">
                                        <div className="yacht-content" id="norman_content">
                                            <a href="#">
                                                <div className="slider-dark-overlay2" 
                                                    style={{
                                                        backgroundImage: `url(${yacht && yacht.featured_image_4 &&
                                                        yacht.featured_image_4.url ? yacht.featured_image_4.url : yatchimg})`
                                                    }}
                                                />
                                                <div className="yacht-text align-bottom">
                                                <h2>{ yacht && yacht.featured_title_4}</h2>
                                            <p>{ yacht && yacht.featured_description_4 && parse(yacht.featured_description_4)}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 no-padding yacht5">
                                        <div className="yacht-content" id="norman_content">
                                            <a href="#">
                                                <div className="slider-dark-overlay2"
                                                    style={{
                                                        backgroundImage: `url(${yacht && yacht.featured_image_5 &&
                                                        yacht.featured_image_5.url ? yacht.featured_image_5.url : yatchimg})`
                                                    }}
                                                />
                                                <div className="yacht-text align-bottom">
                                                <h2>{ yacht && yacht.featured_title_5}</h2>
                                            <p>{ yacht && yacht.featured_description_5 && parse(yacht.featured_description_5)}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* accomodation section */}
                <section id="accomodation" className="section fix accomodation">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="accomation-content">
                                    <h1>Accommodation</h1>
                                    <p>
                                        { yacht && yacht.accommodation && parse(yacht.accommodation) }
                                    </p>

                                    {/* { yacht && yacht.inclusive_terms && yacht.inclusive_terms !== "" ?
                                        [
                                            <h1>Inclusive Terms</h1>,
                                            <p>{yacht.inclusive_terms}</p>
                                        ]
                                    : false }

                                    { yacht && yacht.additional_costs && yacht.additional_costs !== "" ?
                                        [
                                            <h1>Additional Costs</h1>,
                                            <p>{yacht.additional_costs}</p>
                                        ]
                                    : false } */}

                                    <div className="accom-list">
                                        <div className="list">
                                            <div className="accom-icon">
                                                <img src={icon1} className="img-responsive" alt="Guest"/>
                                            </div>
                                            <div className="accom-text">
                                                <p>Guests:<br/>
                                                    <span>{yacht && yacht.number_of_passengers}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="list">
                                            <div className="accom-icon">
                                                <img src={icon2} className="img-responsive" alt="Cabins"/>
                                            </div>
                                            <div className="accom-text">
                                                <p>cabins:<br/>
                                                    <span>{yacht && yacht.number_of_cabins}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="list">
                                            <div className="accom-icon">
                                                <img src={icon3} className="img-responsive" alt="Crew"/>
                                            </div>
                                            <div className="accom-text">
                                                <p>Crew:<br/>
                                                    <span>{yacht && yacht.number_of_members}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6" id="mobtable">
                                <div className="accomation-table">
                                    <h1>Specification</h1>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Length:</td>
                                                <td>{yacht && yacht.length} m / { yacht && Math.round(yacht.length * 3.28)} ft</td>
                                            </tr>
                                            <tr>
                                                <td>Year Built:</td>
                                                <td>{yacht && yacht.build_year}</td>
                                            </tr>
                                            <tr>
                                                <td>Year Refit:</td>
                                                <td>{yacht && yacht.refit_year}</td>
                                            </tr>
                                            <tr>
                                                <td>Yacht Type:</td>
                                                <td>{yacht && yacht.type && yacht.type.name}</td>
                                            </tr>
                                            <tr>
                                                <td>Home Port:</td>
                                                <td>{yacht && yacht.home_port && yacht.home_port.name}</td>
                                            </tr>
                                            <tr>
                                                <td>Flag:</td>
                                                <td>{yacht && yacht.flag && yacht.flag.country_name}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="yachbackground-vector2">
                        <img src={yachtvector} className="img-responsive" alt="Crew"/>
                    </div>
                </section>

                {/* Slider section */}
                <section id="destination-carousel" className="slider_desitnation section fix">
                    <div className="container-fluid">
                        <div className="row desktop-slider">
                        {this.state.SliderImages.length>0?<div className="col-lg-12 col-md-12 no-padding singlepage-carousel">
                                <div>
                                <Slider {...settings}>
                                        {this.state.SliderImages.length>0?
                                        this.state.SliderImages.map((image, i)=>{
                                            return(
                                                <div>
                                                     <img key={i} src={image} className="img-responsive" alt="img responsive" />
                                                </div>
                                            )
                                        }):null
                                        }
                                    </Slider>
                                </div>
                                {
                                    yacht && yacht.images && yacht.images.length > 0
                                    ?
                                    <h4 className="desti_pagin desti_pagination">{this.state.activeSlide < 0 ? 1 : this.state.activeSlide + 1}  / { yacht && yacht.images && yacht.images.length}</h4>
                                    :
                                    false
                                }
                            </div>:null}
                        </div>

                    </div>
                </section>

                {/* New Inclusive Terms Section */}
                <section className="section fix new--terms">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="optional--incl gems-content-div">
                                    <h3 className="toy--head">Toys</h3>
                                    <div className="row">

                                        { yacht && yacht.toys && yacht.toys.map((toy, i)=>{
                                        return(
                                            <div className="col-md-3 col-sm-4 col-12">
                                                <div className="ul__toys--div"><img src={check} className="img-responsive toys--img" alt="Guest"/><span className="games--nm pl-20">{ toy.name }</span></div>
                                            </div>
                                            )
                                        })
                                        }
                                    </div>
                                </div>
                                <div className="new--inclterms gems-content-div">
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <div className="inclusive--txt">
                                                <h5 className="inclusi--header">Inclusive Terms</h5>
                                                <ul className="inclu--ul">
                                                { yacht && yacht.terms && yacht.terms.map((feature, i)=>{
                                                    return(
                                                    <li>{ feature.name }</li>
                                                    )
                                                    })
                                                }
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <div className="inclusive--txt">
                                            <h5 className="inclusi--header">Optional Extras</h5>
                                                <ul className="inclu--ul">
                                                { yacht && yacht.extras && yacht.extras.map((feature, i)=>{
                                                    return(
                                                    <li>{ feature.name }</li>
                                                    )
                                                    })
                                                }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Fourth section */}
                <section id="other-gemsyachts" className="section fix other-gems destina_gems">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="gems-content-div">
                                    <div className="other-gems-cont-left">
                                        <div className="heading">
                                            <h1>Destinations within sailing distance...</h1>
                                        </div>
                                    </div>

                                    <div className="row">
                                        {

                                        this.state.destination_one ?
                                        <Link to={"/destination/" + this.state.destination_one.id }>

                                        <div className="col-lg-6 col-md-6">
                                            <div className="gems">
                                                <div className="gems-img">
                                                    <img src={this.state.destination_one.featured_image.url ? this.state.destination_one.featured_image.url : noimage} className="img-responsive" alt="caribbean"/>
                                                </div>
                                                <div className="gems-content">
                                                    <p className="title">{ this.state.destination_one.title }</p>
                                                    <p className="txt">{this.state.destination_one.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                        </Link>
                                        :
                                        false
                                        }

                                        {

                                        this.state.destination_two ?
                                        <Link to={"/destination/" + this.state.destination_two.id }>

                                        <div className="col-lg-6 col-md-6">
                                            <div className="gems">
                                                <div className="gems-img">
                                                    <img src={this.state.destination_two.featured_image.url ? this.state.destination_two.featured_image.url : noimage} className="img-responsive" alt="caribbean"/>
                                                </div>
                                                <div className="gems-content">
                                                    <p className="title">{ this.state.destination_two.title }</p>
                                                    <p className="txt">{this.state.destination_two.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                        </Link>
                                        :
                                        false
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="background-vector other-grms-vector">
                        <img
                            id="destina_vectorlast"
                            src={vector4}
                            className="img-responsive"
                            alt="Destination vector"/>
                    </div>
                </section>

                {/* Review section */}
                <section id="customer-review" className="section fix customer-review">
                    <div className="container">
                        <div className="review-heading">
                            <h1>Reviews from our customers</h1>
                        </div>
                        <div className="row">
                            {
                            this.state.testimonial_one ?
                            <div className="col-lg-6 col-md-6">
                                <div className="review-content">
                                    <div className="review-txt">
                                        {parse(this.state.testimonial_one.description)}
                                    </div>
                                    <div className="customer-data">
                                        <div className="customer-img">
                                            <img src={this.state.testimonial_one.image.url ? this.state.testimonial_one.image.url : img34} className="img-responsive" alt="img-responsive"/>
                                        </div>
                                        <div className="customer-name">
                                            <p className="name">{this.state.testimonial_one.name},</p>
                                            <p className="country">{this.state.testimonial_one.location}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            false
                            }
                            {
                            this.state.testimonial_two ?
                            <div className="col-lg-6 col-md-6">
                                <div className="review-content">
                                    <div className="review-txt">
                                        {parse(this.state.testimonial_two.description)}
                                    </div>
                                    <div className="customer-data">
                                        <div className="customer-img">
                                            <img src={this.state.testimonial_two.image.url ? this.state.testimonial_two.image.url : img34} className="img-responsive" alt="img-responsive"/>
                                        </div>
                                        <div className="customer-name">
                                            <p className="name">{this.state.testimonial_two.name},</p>
                                            <p className="country">{this.state.testimonial_two.location}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            false
                            }
                        </div>
                    </div>
                </section>

                {/* Last section */}
                <section id="yacht-quote-section" className="section fix yacht-quote-section" style={backgroundStyle}>
                    <div className="container">
                        <div className="row">
                        <div className="col">
                            <div className="quote-content">
                                <h1>
                                    Get a custom quote for this luxury yacht now, we take care of everything so you don't have to
                                </h1>
                                <button id="yacht_quote" className="btn btn-secondary btn-theme quote-btns"><Link to={"/yacht/" + yacht.id + "/get-quote"}>Get a Quote <img src={btnarow3} className="img-responsive" alt="arrow"/></Link></button>
                                <Link to={"/yacht/" + yacht.id + "/dates"}>
                                <button className="btn btn-secondary btn-theme2 availability-btn">
                                <span>Check Availability</span>
                                </button>
                                </Link>
                            </div>
                        </div>
                        </div>
                    </div>
                </section>

                <Footerslider></Footerslider>
                <a href="#pagetop" id="back-to-top" title="Back to top">&uarr;</a>

            </div>
        );
    }

}
export default SimpleSlider;
